var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-inner" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.visible,
            title: _vm.title,
            width: "1050px",
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            "show-close": false,
            top: "5vh",
            "custom-class": "cooperate-branch-popup"
          },
          on: { open: _vm.showDialog }
        },
        [
          _c(
            "el-form",
            {
              staticStyle: { "margin-top": "4px" },
              attrs: {
                inline: true,
                "label-width": "60px",
                "label-position": "left"
              }
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.showCooperateAll,
                      expression: "!showCooperateAll"
                    }
                  ],
                  staticClass: "app-main-inner-row",
                  staticStyle: { padding: "0" }
                },
                [
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.orderCenterBranch ||
                                _vm.hasOpOfficeCooperate,
                              expression:
                                "orderCenterBranch || hasOpOfficeCooperate"
                            }
                          ],
                          style: {
                            width: _vm.$selectByLang(
                              "65px",
                              "65px",
                              "65px",
                              "110px",
                              "65px",
                              "65px"
                            )
                          },
                          attrs: { type: "primary", no: "add" },
                          on: { click: _vm.addHandler }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Add")))]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.orderCenterBranch,
                              expression: "orderCenterBranch"
                            }
                          ],
                          style: {
                            width: _vm.$selectByLang(
                              "65px",
                              "65px",
                              "65px",
                              "110px",
                              "90px",
                              "90px"
                            )
                          },
                          attrs: { type: "primary", no: "edit" },
                          on: { click: _vm.editHandler }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Edit")))]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.orderCenterBranch,
                              expression: "orderCenterBranch"
                            }
                          ],
                          staticStyle: { width: "65px" },
                          attrs: { type: "danger", no: "delete" },
                          on: { click: _vm.deleteHandler }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Delete")))]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.orderCenterBranch,
                              expression: "!orderCenterBranch"
                            }
                          ],
                          staticStyle: { width: "65px" },
                          attrs: { type: "primary", no: "businessStatus" },
                          on: {
                            click: function($event) {
                              return _vm.updateStateHandler(2)
                            }
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("CargoMsg.Cargo_BusinessStatus"))
                          )
                        ]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.orderCenterBranch,
                              expression: "!orderCenterBranch"
                            }
                          ],
                          staticStyle: { width: "65px" },
                          attrs: { type: "primary", no: "chargeStatus" },
                          on: {
                            click: function($event) {
                              return _vm.updateStateHandler(3)
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ChargeStatus")))]
                      ),
                      _c(
                        "el-dropdown",
                        {
                          staticStyle: { "padding-left": "5px" },
                          attrs: { "split-button": "", type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.btnStatusLogHandler()
                            },
                            command: function(p) {
                              _vm.commandCode = p
                              _vm.btnStatusLogHandler()
                            }
                          }
                        },
                        [
                          _vm._v(" " + _vm._s(_vm.commandCode) + " "),
                          _c(
                            "el-dropdown-menu",
                            { attrs: { slot: "dropdown" }, slot: "dropdown" },
                            [
                              _c(
                                "el-dropdown-item",
                                {
                                  attrs: {
                                    command: _vm.$t(
                                      "CargoMsg.Cargo_CooperateStatusLog"
                                    ),
                                    no: "cooperateStatusLog"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "CargoMsg.Cargo_CooperateStatusLog"
                                      )
                                    ) + " "
                                  )
                                ]
                              ),
                              _c(
                                "el-dropdown-item",
                                {
                                  attrs: {
                                    command: _vm.$t(
                                      "CargoMsg.Cargo_BusinessStatusLog"
                                    ),
                                    no: "businessStatusLog"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("CargoMsg.Cargo_BusinessStatusLog")
                                    ) + " "
                                  )
                                ]
                              ),
                              _c(
                                "el-dropdown-item",
                                {
                                  attrs: {
                                    command: _vm.$t(
                                      "CargoMsg.Cargo_ChargeStatusLog"
                                    ),
                                    no: "chargeStatusLog"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("CargoMsg.Cargo_ChargeStatusLog")
                                    ) + " "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-button",
                        {
                          staticStyle: { width: "65px", "margin-left": "5px" },
                          attrs: { type: "primary" },
                          on: { click: _vm.refreshHandler }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Refresh")))]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.orderCenterBranch,
                              expression: "orderCenterBranch"
                            }
                          ],
                          style: {
                            width: _vm.$selectByLang(
                              "65px",
                              "65px",
                              "65px",
                              "165px",
                              "165px",
                              "150px"
                            )
                          },
                          attrs: { type: "primary", no: "profitShareAdjust" },
                          on: { click: _vm.profitShareAdjustHandler }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("CargoMsg.Cargo_ProfitShareAdjust"))
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "app-main-inner-row row-grid",
                  staticStyle: { "min-height": "320px", padding: "0" }
                },
                [
                  _c("cargo-ag-grid", {
                    style: { width: "610px", height: "321px" },
                    attrs: {
                      "config-module": "101355",
                      "grid-options": _vm.gridOptions,
                      "column-defs": _vm.columnDefs,
                      "row-data": _vm.rowData
                    }
                  })
                ],
                1
              )
            ]
          ),
          _c(
            "div",
            {
              staticStyle: { height: "25px" },
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "span",
                {
                  staticStyle: {
                    position: "absolute",
                    right: "0",
                    "padding-right": "10px"
                  }
                },
                [
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.controlConfirmButton ||
                            _vm.hasOpOfficeCooperate,
                          expression:
                            "controlConfirmButton || hasOpOfficeCooperate"
                        }
                      ],
                      attrs: { type: "primary", no: "confirm" },
                      on: { click: _vm.onOK }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Confirm")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.controlConfirmButton ||
                            _vm.hasOpOfficeCooperate,
                          expression:
                            "controlConfirmButton || hasOpOfficeCooperate"
                        }
                      ],
                      staticStyle: { width: "65px", "margin-left": "5px" },
                      attrs: { no: "cancel" },
                      on: { click: _vm.onCancel }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            !_vm.controlConfirmButton &&
                            !_vm.hasOpOfficeCooperate,
                          expression:
                            "!controlConfirmButton && !hasOpOfficeCooperate"
                        }
                      ],
                      attrs: { type: "primary", no: "close" },
                      on: { click: _vm.onCancel }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Close")))]
                  )
                ],
                1
              )
            ]
          )
        ],
        1
      ),
      _vm.cooperationBranchDialog.visible
        ? _c("cooperation-branch-dialog", {
            attrs: {
              visible: _vm.cooperationBranchDialog.visible,
              "job-uuid": _vm.cooperationBranchDialog.jobUuid,
              cooperate: _vm.cooperationBranchDialog.cooperate,
              "submit-call-back": _vm.cooperationBranchDialog.submitCallBack,
              editable: _vm.cooperationBranchDialog.editable,
              "action-desc": _vm.cooperationBranchDialog.actionDesc,
              rows: _vm.rowData,
              "op-office": _vm.job.opOffice
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.cooperationBranchDialog, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _vm.cooperateStatusDialog.visible
        ? _c("cooperate-status-dialog", {
            attrs: {
              visible: _vm.cooperateStatusDialog.visible,
              "status-type-desc": _vm.cooperateStatusDialog.statusTypeDesc,
              "update-state-call-back":
                _vm.cooperateStatusDialog.updateStateCallBack
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.cooperateStatusDialog, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _vm.cooperateStatusLogDialog.visible
        ? _c("cooperate-status-log-dialog", {
            attrs: {
              visible: _vm.cooperateStatusLogDialog.visible,
              uuid: _vm.cooperateStatusLogDialog.uuid,
              "status-type": _vm.cooperateStatusLogDialog.statusType,
              "status-type-desc": _vm.cooperateStatusLogDialog.statusTypeDesc
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.cooperateStatusLogDialog, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _vm.profitShareDialog.visible
        ? _c("profit-share-dialog", {
            attrs: {
              visible: _vm.profitShareDialog.visible,
              "job-uuid": this.jobUuid,
              job: this.job,
              "init-share-amount": _vm.initShareAmount,
              "share-branch-list": _vm.shareBranchList
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.profitShareDialog, "visible", $event)
              },
              confirm: _vm.profitShareConfirmHandler
            }
          })
        : _vm._e(),
      _vm.profitShareAdjustDialog.visible
        ? _c("profit-share-adjust-dialog", {
            attrs: {
              visible: _vm.profitShareAdjustDialog.visible,
              "job-uuid": this.jobUuid,
              job: this.job,
              "share-amount": _vm.shareAmount,
              "share-amounts": _vm.shareAmounts,
              "init-share-amount": _vm.initShareAmount,
              "share-branch-list": _vm.shareBranchList
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.profitShareAdjustDialog, "visible", $event)
              },
              confirm: _vm.profitShareConfirmHandler
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }